export default __webpack_public_path__ + "static/media/eye-inactive-icon.a92f37c2.svg";